import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=ac61cf8a&scoped=true&"
import script from "./CouponItem.vue?vue&type=script&lang=ts&"
export * from "./CouponItem.vue?vue&type=script&lang=ts&"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=ac61cf8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac61cf8a",
  null
  
)

export default component.exports